export const getCompleteSprintFormOptions = (collection, activeSprintId) => {
	const filteredCollection = collection.filter((x) => x.Id !== activeSprintId);
	console.log('filteredCollection', filteredCollection);
	return filteredCollection.map((x, i) => {
		return {
			id: i === filteredCollection.length - 1 ? '' : x.Id,
			title: i === filteredCollection.length - 1 ? 'بک لاگ' : x.Title
		};
	});
};
